module.exports = __webpack_public_path__ + "img/famale.f00348d9.png";